import React, { useEffect } from "react";
import { actions, selectors } from "@containers/PayPerLead/store";
import { useDispatch, useSelector } from "react-redux";
import { getActiveAccount } from "@containers/Account/store/selectors";
import { getFullName } from "@shared/utils";
import { User } from "@shared/models";
import { MODAL_TYPES } from "@shared/constants";
import { actions as sharedActions, selectors as sharedSelectors } from "@shared/store";
import { Button, Icon } from "@shared/components";
import "./index.scss";
import { ModalSize } from "@shared/interfaces";

const PPLBuyerProfile = () => {
  const dispatch = useDispatch();
  const account = useSelector(getActiveAccount());
  const buyerProfile = useSelector(selectors.getPPLBuyerProfile());
  const currentUser = useSelector(sharedSelectors.getUserDetails());

  useEffect(() => {
    dispatch(actions.fetchBuyerProfile.request(account?.id as number));
  }, [account, dispatch]);

  const editBuyer = () =>
    dispatch(
      sharedActions.showModal({
        type: MODAL_TYPES.PPL_BUYER_PROFILE,
        closeIcon: true,
        size: ModalSize.LG,
        props: {
          heading: "Introduce yourself to a potential seller",
          content:
            "Share your company information and reach-out person contact details to make the user experience more personalized and increase the reach out conversion.",
          successBtnText: "Pay",
          onSuccess: () => null,
          data: { buyerProfile },
        },
      }),
    );

  return (
    <div className="card-item">
      <div className="content">
        <div className="header">
          <div className="title">BUYERS PROFILE</div>
          {account?.user_id === currentUser?.id && (
            <Button buttonStyle="link" onClick={editBuyer} className="link-underline">
              {buyerProfile ? "Edit Info" : "Add Info"}
            </Button>
          )}
        </div>

        <div className="info">
          <div className="photo">
            <div className="overlap">
              {buyerProfile?.agent_photo_url ? (
                <div className="image-wrapper">
                  <img className="photo-img" src={buyerProfile?.agent_photo_url} alt="Profile" />
                </div>
              ) : (
                <div className="user-icon">
                  <Icon type="nav-users" />
                </div>
              )}

              {buyerProfile?.logo_url ? (
                <div className="logo">
                  <div className="company-logo">
                    <div className="overlap-group">
                      <img className="company-icon" src={buyerProfile?.logo_url || undefined} alt="Company Logo" />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {buyerProfile && (
            <div className="title">
              <div className="name">
                <span>{buyerProfile?.agent_name || getFullName(account?.primary_user as User)}</span>
              </div>
              <div className="company">
                <span>{buyerProfile?.name || account?.name}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PPLBuyerProfile;
